import React from 'react';
import ContentLayout from '../ContentLayout';
import UserContent from './UserContent';


function ManageUsersList() {

    return (
        <ContentLayout customClassName='manage-user-list-content-layout'>
            <UserContent/>
        </ContentLayout>
    );

}

export default ManageUsersList;
